const dateTimeFormat = (date) => {
    return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
        timeZone: 'Europe/Lisbon',
    })
        .formatToParts(new Date(date))
        .reduce((acc, part) => {
            acc[part.type] = part.value;

            return acc;
        }, {});
};

export function setUpperCase(str) {
    return str?str.toUpperCase():str
}

export function formatDate(date) {
    const fmt = dateTimeFormat(date);

    return `${fmt.year}-${fmt.month}-${fmt.day}`;
}

export function formatDateTime(datetime, showSeconds = true) {
    const fmt = dateTimeFormat(datetime);
    let formattedDate = `${fmt.year}-${fmt.month}-${fmt.day} ${fmt.hour}:${fmt.minute}`;

    if (showSeconds) formattedDate += `:${fmt.second}`;

    return formattedDate;
}

export function formatPrice(price) {
    if (typeof price === 'string') {
        price = parseFloat(price);
    }

    if (typeof price === 'number') {
        // Using de-DE since it returns the desired format
        return price.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
        });
    }

    return price;
}

export function formatIntegerPrice(price,min=0,max=0) {
    if (typeof price === 'string') {
        price = parseFloat(price);
    }

    if (typeof price === 'number') {
        // Using de-DE since it returns the desired format
        return price.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: min,
            maximumFractionDigits: max,
        });
    }

    return price;
}

export function formatDecimal(value, places = 2) {
    let baseValue = parseFloat(value); // Handle stringified decimals from the backend, for Math.round()
    const roundingMultiplier = Math.pow(10, places);

    baseValue = baseValue >= 0 ? baseValue + Number.EPSILON : baseValue - Number.EPSILON;

    return Math.round(baseValue * roundingMultiplier) / roundingMultiplier;
}

export function formatQuantity(price) {
    if (typeof price === 'string') {
        price = parseFloat(price);
    }

    if (typeof price === 'number') {

        // Using de-DE since it returns the desired format
        price = price.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    }

    return price.replace('€','');
}
